<template>
  <footer class="relative z-10 w-full mt-32">
    <div class="max-w-7xl mx-auto px-5">
      <div
        class="w-full mx-auto bg-gray-50 rounded-2xl p-8 md:p-12 md:pb-6 pb-6 text-center mb-10 shadow-xl"
      >
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-10">
          <!-- Contact -->
          <div class="space-y-2">
            <p class="text-xs font-bold text-gray-900 uppercase tracking-wider">
              條款與查詢
            </p>
            <router-link
              to="/order-search"
              class="block text-sm font-medium text-gray-600 hover:text-black transition-colors"
              >訂單查詢</router-link
            >
            <router-link
              to="/terms/site_privacy"
              class="block text-sm font-medium text-gray-600 hover:text-black transition-colors"
              >隱私權政策</router-link
            >
            <router-link
              to="/terms/return_policy"
              class="block text-sm font-medium text-gray-600 hover:text-black transition-colors"
              >退換貨政策</router-link
            >
          </div>
          <!-- Address -->
          <div class="space-y-2">
            <p class="text-xs font-bold text-gray-900 uppercase tracking-wider">
              公司資訊
            </p>
            <p class="text-sm font-medium text-gray-900">
              {{ $GetColumn("company_name") }}
            </p>
            <p
              class="text-sm text-gray-500"
              v-if="$GetColumn('company_address') != ''"
            >
              {{ $GetColumn("company_address") }}
            </p>
            <p
              class="text-sm text-gray-500"
              v-if="$GetColumn('company_phone') != ''"
            >
              {{ $GetColumn("company_phone") }}
            </p>
            <a
              :href="`mailto:${$GetColumn('company_email')}`"
              class="block text-sm text-gray-500"
              v-if="$GetColumn('company_email') != ''"
            >
              {{ $GetColumn("company_email") }}</a
            >
          </div>
          <!-- Social -->
          <div
            class="space-y-2"
            v-if="
              $GetColumn('company_facebook') != '' ||
              $GetColumn('company_instagram') != '' ||
              $GetColumn('company_line') != ''
            "
          >
            <p class="text-xs font-bold text-gray-900 uppercase tracking-wider">
              社群平台
            </p>
            <a
              :href="$GetColumn('company_facebook')"
              target="_blank"
              class="block text-sm text-gray-500 font-medium"
              v-if="$GetColumn('company_facebook') != ''"
              >FACEBOOK</a
            >
            <a
              :href="$GetColumn('company_instagram')"
              target="_blank"
              class="block text-sm text-gray-500 font-medium"
              v-if="$GetColumn('company_instagram') != ''"
              >INSTAGRAM</a
            >
            <a
              :href="$GetColumn('company_line')"
              target="_blank"
              class="block text-sm text-gray-500 font-medium"
              v-if="$GetColumn('company_line') != ''"
              >LINE@</a
            >
          </div>
        </div>

        <div class="border-t border-gray-200 pt-6">
          <p class="text-xs text-gray-400">
            © {{ new Date().getFullYear() }} {{ $GetColumn("company_name") }}.
            All Rights Reserved.
          </p>
        </div>
      </div>
    </div>

    <div class="border-t border-zinc-200 py-3">
      <div
        class="flex flex-col items-center justify-center w-full px-5 mx-auto md:flex-row max-w-7xl"
      >
        <p class="text-xs text-center text-zinc-600">
          本系統由
          <a href="https://one.yongxin-design.com/" target="_blank"
            >快樂購物系統</a
          >
          維護
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "MainFooter",
};
</script>
